import {SpinnerService} from "../../modules/SpinnerModule";
import * as moment from 'moment';
import {DataHubService} from "../../modules/DataHubModule";

export function XheoExtensionController($dataHub: DataHubService, $location, $q, $spinner:SpinnerService) {
    var vm = this;
    vm.rows = [];
    vm.extensionOptions = [7, 15, 30, 60];

    $dataHub.client.bindAllXheoExtension(() => vm.rows);

    vm.refresh = () => {
        $spinner.show('Loading');
        $dataHub.server.xheoExtensionSub()
            .then(e => console.log('done', e))
            .catch(e => console.error(e))
            .finally(() => $spinner.hide());
    };

    $dataHub.onConnected(vm.refresh);

    vm.extend = (row, days) =>
    {
        row.expirationDate = moment().add(days, 'days').toDate();
        $dataHub.server.xheoExtensionSave(row);
    }

}
